import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// ---------------------------------------------------------------------------
// Suppress React dev-overlay noise from browser extensions.
//
// The CRA development error overlay hooks into the global `error` and
// `unhandledrejection` events. Errors thrown by Chrome/Firefox extensions
// (chrome-extension:// or moz-extension:// URLs) are completely outside our
// codebase and cannot be fixed here — but they do trigger the blocking red
// overlay in dev mode. Registering a capture-phase listener first lets us
// call stopImmediatePropagation() before CRA's handler ever runs, so
// extension errors are silently ignored while every real app error still
// surfaces normally.
// ---------------------------------------------------------------------------
if (process.env.NODE_ENV === "development") {
  const EXTENSION_ORIGINS = ["chrome-extension://", "moz-extension://"];

  const isExtensionError = (source) =>
    typeof source === "string" &&
    EXTENSION_ORIGINS.some((prefix) => source.startsWith(prefix));

  // Capture-phase: fires before CRA's own listener.
  window.addEventListener(
    "error",
    (event) => {
      if (isExtensionError(event.filename)) {
        event.stopImmediatePropagation();
      }
    },
    true, // capture phase — runs before bubble-phase listeners
  );

  // Also suppress unhandled promise rejections triggered by extensions.
  window.addEventListener(
    "unhandledrejection",
    (event) => {
      const src =
        event.reason?.stack || event.reason?.fileName || "";
      if (isExtensionError(src)) {
        event.stopImmediatePropagation();
      }
    },
    true,
  );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
);

// If you want to start measuring performance in your app, pass a function

// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

